import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  withStyles
} from 'material-ui/styles'
import Grid from 'material-ui/Grid'
import Typography from 'material-ui/Typography/Typography';

import * as SiteConfig from '../../config/Config'

const styles = theme => ({
  outsideBg: {
    backgroundColor: theme.palette.background,
  },
  columnBg: {
    color: theme.palette.text.primary,
  },
  copyright: {
    color: `${theme.palette.type === 'dark' ? theme.palette.secondary.main : theme.palette.primary.main}`,
    padding: 10,
  },
  developer: {
    color: `${theme.palette.type === 'dark' ? theme.palette.secondary.main : theme.palette.primary.main}`,
    padding: 10,
  },
  developerSite: {
    color: theme.palette.primary.light,
    textDecoration: 'none',
    fontWeight: 'bold',
  },
})

class RightsAndAttribution extends Component {
  render() {

    const { classes } = this.props
    
    return (
      <Grid
        /* full width background */
        container
        spacing={0}
        justify="center"
        className={classes.outsideBg}
      >
        <Grid
          /* page center column */
          item
          xs={11}
          md={10}
          className={classes.columnBg}
        >

          <Grid container spacing={0}>
            {/* Site Rights */}
            <Grid item xs={12}>
              <Typography
                variant="caption"
                component="p"
                align="center"
                className={classes.copyright}
              >
                &copy; {`${SiteConfig.business.copyrightStartDate} - ${new Date().getFullYear()} ${SiteConfig.business.name} | All Rights Reserved`}
              </Typography>
            </Grid>

            {/* Developer */}
            <Grid item xs={12}>
              <Typography
                variant="caption"
                component="p"
                align="center"
                className={classes.developer}
              >
                {`Website Made in the USA by `}
                <a
                  href={SiteConfig.developer.site}
                  className={classes.developerSite}
                >
                  {SiteConfig.developer.company}
                </a>
              </Typography>
            </Grid>
          </Grid>


        </Grid>

      </Grid>
    );
  }
}

RightsAndAttribution.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RightsAndAttribution)


// WEBPACK FOOTER //
// ./src/components/RightsAndAttribution/index.js